<template>
    <b-form-group :label="$t('daily.initiative')">
        <b-form-input :value="value" :placeholder="placeholder" :state="state" @input="$emit('input', $event)" />
    </b-form-group>
</template>
<script>
export default {
    props: {
        value: String,
        placeholder: String,
        state: Boolean,
    },
}
</script>
